

exports.__esModule = true;
exports.$AddressNormalizationEditRoute = undefined;

var _squid = require('squid');

require('./directive');

var $AddressNormalizationEditRoute = exports.$AddressNormalizationEditRoute = _squid.$ComponentRoute.extend('AddressNormalizationEditRoute', {
    name: 'addressNormalizationEdit',
    titleContent: 'addressNormalization.addressmatch',
    directive: 'xo-address-normalization-edit',
    trackingData: {
        fptiState: 'address_normalization_edit',
        buzname: {
            'fullpage': {
                'pagename': '%::address_normalization_edit',
                'pagename2': '%::address_normalization_edit:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,

    children: []
});

angular.value("$AddressNormalizationEditRoute", $AddressNormalizationEditRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-address-components/src/address-normalization-edit/route.js
// module id = ../node_modules/xo-address-components/src/address-normalization-edit/route.js
// module chunks = 0